<rid-mechanic-background />

<rid-mechanic-wrapper [class.cursor-grabbing]="isDragging()">
  <rid-top-bar class="block w-full" name="Klankbord plus | klankvoeten" [steps]="assignments().length" [progress]="index()" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Sleep het woord naar de juiste splitsregel'" />

    <!-- isolated so the dragged word's z-index only lifts it above the rule cards, not above the modal -->
    <div class="absolute isolate grid h-[34rem] w-full grid-rows-[1fr_auto] justify-items-center">
      <!-- word -->
      <div class="relative grid w-full place-items-center">
        @for (a of [assignment()]; track a) {
          <div
            #draggable="cdkDrag"
            cdkDrag
            class="group absolute z-10"
            [class]="{
              'pointer-events-none': isDragging() || isEvaluating(),
              'cursor-grab': !isDragging() && !isEvaluating(),
            }"
            animate.leave="anim-fade-out"
            (cdkDragStarted)="onDragStarted()"
            (cdkDragMoved)="onDragMoved($event)"
            (cdkDragReleased)="onDragReleased()"
          >
            <div class="ease-in-back transition-transform" [class.scale-0]="isCorrect()">
              <rid-audio-card
                #audioCard
                class="block transition-transform"
                [class]="{
                  'group-hover:shadow-md': !isDragging(),
                  'shadow-lg': isDragging(),
                  'group-hover:scale-105': !isDragging(),
                  'scale-115': isDragging(),
                  'group-hover:-rotate-1': !isDragging(),
                  '-rotate-5': isDragging(),
                }"
                [src]="a.audio"
                animate.enter="wait-500 anim-pop-in"
                ridSfx="BUBBLE_POP"
                (animationend)="$event.animationName === 'pop-in' ? onWordPoppedIn() : undefined"
              />
            </div>
          </div>
        }
      </div>

      <!-- rules -->
      <div
        class="flex gap-12 pb-8"
        [class.pointer-events-none]="!areRulesVisible()"
        [class.invisible]="!areRulesVisible()"
        [attr.aria-hidden]="!areRulesVisible()"
      >
        @for (rule of rules; track rule) {
          <div
            class="transition-all"
            [attr.data-rule]="rule"
            [class]="{
              'scale-110': target() === rule,
              'scale-95': (isDragging() || isEvaluating()) && target() !== undefined && target() !== rule,
              'grayscale-100': (isDragging() || isEvaluating()) && target() !== undefined && target() !== rule,
            }"
          >
            <div
              class="rounded-xl border-4 bg-white px-8 py-5 text-4xl text-slate-700 transition-colors"
              [class]="{
                'border-surface-300': !isEvaluating() || target() !== rule,
                'border-emerald-500': isEvaluating() && target() === rule && isCorrect(),
                'border-red-500': isEvaluating() && target() === rule && !isCorrect(),
                'anim-pop-in': areRulesVisible(),
              }"
              [style.animation-delay.ms]="areRulesVisible() ? $index * 100 : null"
            >
              <rid-klankvoet-rule-glyph [rule]="rule" />
            </div>
          </div>
        }
      </div>
    </div>

    <!-- explanation dialog -->
    @if (showExplanation()) {
      <rid-modal-background [blur]="true" />
      <rid-klankvoet-rule-modal ridSfx="HINT" [rule]="assignment().rule" (continue)="closeExplanation()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
